import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from 'react-router-dom';

const ResetPassword = () => {
    const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [formValues, setFormValues] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [formErrors, setFormErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  // Extract token and email from query parameters
  const token = searchParams.get("token");
  const email = searchParams.get("email");

  // Regex for password policy
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  // Validate form
  const validateForm = () => {
    const errors = {};

    // Validate password policy
    if (!formValues.newPassword || !passwordRegex.test(formValues.newPassword)) {
      errors.newPassword =
        "Password must contain at least 8 characters, one uppercase, one lowercase, one number, and one special character.";
    }

    // Validate confirm password
    if (formValues.newPassword !== formValues.confirmPassword) {
      errors.confirmPassword = "Passwords do not match.";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        const response = await fetch("/api/reset-password", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            token,
            email,
            newPassword: formValues.newPassword,
          }),
        });

        if (response.ok) {
          setSuccessMessage("Password reset successfully! You can now sign in.");
          navigate('/');  // Redirect to main page
        } else {
          const error = await response.text();
          alert(error || "Failed to reset password. Please try again.");
        }
      } catch (error) {
        console.error("Error:", error);
        alert("An error occurred. Please try again later.");
      }
    }
  };

  // Redirect if token or email is missing
  useEffect(() => {
    if (!token || !email) {
      alert("Invalid password reset link.");
      window.location.href = "/main"; // Redirect to home
    }
  }, [token, email]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
        padding: "20px",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: "30px",
          borderRadius: "10px",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
          width: "400px",
        }}
      >
        <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
          Reset Password
        </h2>
        {successMessage ? (
          <div style={{ textAlign: "center", color: "green" }}>
            {successMessage}
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            {/* New Password */}
            <div style={{ marginBottom: "20px" }}>
              <label
                style={{
                  fontWeight: "bold",
                  marginBottom: "10px",
                  display: "block",
                }}
              >
                New Password:
              </label>
              <input
                type={showPassword ? "text" : "password"}
                name="newPassword"
                value={formValues.newPassword}
                onChange={handleInputChange}
                placeholder="Enter new password"
                required
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                  fontSize: "14px",
                }}
              />          
              <small style={{ color: "grey" }}>Password must contain at least 8 characters, one uppercase, one lowercase, one number, and one special character./n</small>
              {formErrors.newPassword && (
                <small style={{ color: "red" }}>{formErrors.newPassword}</small>
              )}
            </div>

            {/* Confirm Password */}
            <div style={{ marginBottom: "20px" }}>
              <label
                style={{
                  fontWeight: "bold",
                  marginBottom: "10px",
                  display: "block",
                }}
              >
                Confirm Password:
              </label>
              <input
                type={showPassword ? "text" : "password"}
                name="confirmPassword"
                value={formValues.confirmPassword}
                onChange={handleInputChange}
                placeholder="Confirm new password"
                required
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                  fontSize: "14px",
                }}
              />
              {formErrors.confirmPassword && (
                <small style={{ color: "red" }}>
                  {formErrors.confirmPassword}
                </small>
              )}
            </div>

            {/* Show Password Checkbox */}
            <div style={{ marginBottom: "20px" }}>
              <input
                type="checkbox"
                checked={showPassword}
                onChange={() => setShowPassword(!showPassword)}
                style={{ marginRight: "5px" }}
              />
              <label>Show Password</label>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              style={{
                width: "100%",
                padding: "10px",
                backgroundColor: "green",
                color: "white",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                fontWeight: "bold",
                fontSize: "1rem",
              }}
            >
              Reset Password
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
